import { AttributeValidationHandler } from '../ui-element.type';
import { getDebugMode } from '../../global/config';
import type { UIFeedback } from './ui-feedback';

/**
 * @param {UIFeedback} component
 * @param {string} value
 * @private
 */
export const validateFeedbackLayout: AttributeValidationHandler<UIFeedback> = (
    component: UIFeedback,
    value: string
): void => {
    if (getDebugMode() && value === 'simple') {
        const info = `Use 'default' layout instead`;
        console.warn(`${value} - layout is deprecated: ${info}`, component);
    }
};

/**
 * @param {UIFeedback} component
 * @private
 */
export const validateFeedbackExtensionLayout: AttributeValidationHandler<
    UIFeedback
> = (component: UIFeedback, _value: string): void => {
    if (getDebugMode()) {
        const info = `Use 'default' layout instead`;
        console.warn(`extension-layout is deprecated: ${info}`, component);
    }
};
